<template>
  <iframe :src="link" width="100%" height="600"></iframe>
</template>

<script>
export default {
  props: {
    link: String
  }
}
</script>
